import { buildFaqPageSchema } from '@core-mkt/services/schema/faq-schema.util';
import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import type { FAQData } from './faq';

/**
 * Returns a FAQPage schema node for the static FAQ component. Flattens
 * `sections[].questions[]` into a single `mainEntity` list since the section
 * grouping is presentational, not semantic. State-based answer overrides are
 * intentionally NOT applied — Googlebot crawls without geolocation, so schema
 * must reflect the default rendered content rather than any state-specific
 * variant. The component is gated as a true FAQ by virtue of being the FAQ
 * component, so no looksLikeFaq guard.
 */
export function getFaqSchema(data: FAQData | null | undefined, pageUrl: string): SchemaOrgNode | null {
  if (!data?.sections?.length) return null;

  const questions = data.sections.flatMap((section) =>
    (section.questions ?? []).map((q) => ({
      question: q.question,
      answer: q.answer,
    })),
  );

  return buildFaqPageSchema({
    '@id': `${pageUrl}#faq`,
    questions,
  });
}
